module.exports = __webpack_public_path__ + "img/Frame8670@2x.ab10a96f.png";